(function () {
  'use strict';
  if (window.__regLpInit) return;
  window.__regLpInit = true;

  /* FAQ — single-open accordion (design spec: opening one closes the rest). */
  function initFaq(root) {
    if (!root || root.dataset.regFaqInit === '1') return;
    root.dataset.regFaqInit = '1';
    var items = root.querySelectorAll('.reg-lp__faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.reg-lp__faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var b = other.querySelector('.reg-lp__faq-q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* Sticky bar — slides in once the hero scrolls out of view.
     While it is on screen, lift TrueVault (and the rest of the floating stack)
     above it on mobile and desktop so the cookie control does not cover Add to cart. */
  function syncStickyFloatingWidgets(bar) {
    var widgets = window.TTStickyFloatingWidgets;
    if (!widgets || !bar) return;
    if (!bar.classList.contains('is-visible')) {
      widgets.syncBase();
      return;
    }
    var height = Math.round(bar.getBoundingClientRect().height) || 0;
    widgets.sync(height + 12, { allowDesktop: true });
  }

  function initSticky(bar) {
    if (!bar || bar.dataset.regStickyInit === '1') return;
    bar.dataset.regStickyInit = '1';
    var hero = document.querySelector('.reg-lp__hero');
    var lastWidgetState = '';
    function update() {
      if (!hero) {
        bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.85);
      } else {
        var heroBottom = hero.getBoundingClientRect().bottom;
        bar.classList.toggle('is-visible', heroBottom < 0);
      }
      var visible = bar.classList.contains('is-visible');
      var height = visible ? Math.round(bar.getBoundingClientRect().height) : 0;
      var widgetState = visible ? 'on:' + height : 'off';
      if (widgetState === lastWidgetState) return;
      lastWidgetState = widgetState;
      syncStickyFloatingWidgets(bar);
    }
    document.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Smooth scroll for same-page anchors (e.g. "See the routine"). */
  function initAnchors() {
    document.querySelectorAll('.reg-lp a[href^="#"]').forEach(function (a) {
      if (a.dataset.regAnchorInit === '1') return;
      a.dataset.regAnchorInit = '1';
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* Money — cents to "$12" / "$12.50". Store trades in USD. */
  function fmtMoney(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  /* Offer — variant option pills + one-time/subscribe plan picker.
     Reads variant + selling-plan data from the section's JSON script.
     Some variants have no selling plans; the subscribe row hides for those. */
  function initOffer(section) {
    if (!section || section.dataset.regOfferInit === '1') return;
    section.dataset.regOfferInit = '1';

    var dataEl = section.querySelector('[data-reg-offer-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var els = {
      pills: section.querySelectorAll('[data-reg-opt]'),
      compare: section.querySelector('[data-reg-compare]'),
      price: section.querySelector('[data-reg-price]'),
      oncePlan: section.querySelector('[data-reg-plan="once"]'),
      subPlan: section.querySelector('[data-reg-plan="sub"]'),
      oncePrice: section.querySelector('[data-reg-once-price]'),
      subPrice: section.querySelector('[data-reg-sub-price]'),
      freqWrap: section.querySelector('[data-reg-freq-wrap]'),
      freq: section.querySelector('[data-reg-freq]'),
      idInput: section.querySelector('[data-reg-id]'),
      planInput: section.querySelector('[data-reg-selling-plan]'),
      save: section.querySelector('[data-reg-save]'),
      saveWrap: section.querySelector('[data-reg-save-wrap]'),
      mediaImg: section.querySelector('[data-reg-offer-img]')
    };

    var initialId = parseInt(section.dataset.regDefaultVariant || '0', 10);
    var current = variants.find(function (v) { return v.id === initialId; }) ||
                  variants.find(function (v) { return v.available; }) ||
                  variants[0];
    var selected = current.options.slice();
    var plan = 'once';
    var planId = null;

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function render() {
      var variant = findVariant(selected) || current;
      current = variant;

      // Swap the bundle photo to the selected variant's image (only when the
      // section has no manual override image — see data-reg-offer-img).
      if (els.mediaImg && variant.image && els.mediaImg.getAttribute('src') !== variant.image) {
        els.mediaImg.src = variant.image;
      }

      els.pills.forEach(function (pill) {
        var idx = parseInt(pill.dataset.optIndex, 10);
        var val = pill.dataset.optValue;
        pill.classList.toggle('is-selected', selected[idx] === val);
        // A value is "unavailable" if no variant offers it alongside the other selections.
        var test = selected.slice();
        test[idx] = val;
        var match = findVariant(test);
        pill.classList.toggle('is-unavailable', !match || !match.available);
        pill.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
      });

      var plans = variant.plans || [];
      var hasPlans = plans.length > 0;
      if (!hasPlans && plan === 'sub') plan = 'once';
      if (hasPlans && (planId === null || !plans.some(function (p) { return p.id === planId; }))) {
        planId = plans[0].id;
      }

      if (els.subPlan) els.subPlan.classList.toggle('is-hidden', !hasPlans);
      if (els.oncePlan) {
        els.oncePlan.classList.toggle('is-selected', plan === 'once');
        els.oncePlan.setAttribute('aria-pressed', plan === 'once' ? 'true' : 'false');
      }
      if (els.subPlan) {
        els.subPlan.classList.toggle('is-selected', plan === 'sub');
        els.subPlan.setAttribute('aria-pressed', plan === 'sub' ? 'true' : 'false');
      }
      if (els.freqWrap) els.freqWrap.classList.toggle('is-hidden', plan !== 'sub' || !hasPlans);

      if (els.freq && hasPlans) {
        els.freq.innerHTML = '';
        plans.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p.id;
          opt.textContent = p.name;
          if (p.id === planId) opt.selected = true;
          els.freq.appendChild(opt);
        });
      }

      var activePlan = plans.find(function (p) { return p.id === planId; });
      var effective = plan === 'sub' && activePlan ? activePlan.price : variant.price;

      if (els.compare) els.compare.textContent = fmtMoney(variant.compare);
      if (els.price) els.price.textContent = fmtMoney(effective);
      if (els.oncePrice) els.oncePrice.textContent = fmtMoney(variant.price);
      if (els.subPrice && activePlan) els.subPrice.textContent = fmtMoney(activePlan.price);

      if (els.save && els.saveWrap) {
        var pct = variant.compare > effective ? Math.round((variant.compare - effective) / variant.compare * 100) : 0;
        els.saveWrap.style.display = pct > 0 ? '' : 'none';
        els.save.textContent = pct + '%';
      }

      if (els.idInput) els.idInput.value = variant.id;
      if (els.planInput) {
        if (plan === 'sub' && activePlan) {
          els.planInput.value = activePlan.id;
          els.planInput.disabled = false;
        } else {
          els.planInput.value = '';
          els.planInput.disabled = true;
        }
      }
    }

    els.pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.dataset.optIndex, 10);
        var val = pill.dataset.optValue;
        selected[idx] = val;
        // If that combo doesn't exist, jump to the first variant carrying this value.
        if (!findVariant(selected)) {
          var fallback = variants.find(function (v) { return v.options[idx] === val && v.available; }) ||
                         variants.find(function (v) { return v.options[idx] === val; });
          if (fallback) selected = fallback.options.slice();
        }
        render();
      });
    });

    function bindPlan(el, value) {
      if (!el) return;
      el.addEventListener('click', function (e) {
        if (e.target && e.target.tagName === 'SELECT') return;
        plan = value;
        render();
      });
      el.addEventListener('keydown', function (e) {
        if (e.target && e.target.tagName === 'SELECT') return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          plan = value;
          render();
        }
      });
    }
    bindPlan(els.oncePlan, 'once');
    bindPlan(els.subPlan, 'sub');
    if (els.freq) {
      els.freq.addEventListener('change', function () {
        planId = parseInt(els.freq.value, 10);
        render();
      });
    }

    render();
  }

  /* AJAX add-to-cart: intercept any form[action*="/cart/add"] inside .reg-lp,
     POST to /cart/add.js, then trigger the theme's side cart drawer. */
  function doAjaxAdd(form) {
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      if (window.$s && typeof window.$s.addToCartSuccess === 'function') {
        window.$s.addToCartSuccess();
      } else if (window.SideCart && typeof window.SideCart.updateSideCart === 'function') {
        window.SideCart.updateSideCart(true);
      } else {
        location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch(function (err) {
      var msg = (err && err.description) || 'Could not add to cart.';
      if (window.$s && typeof window.$s.addToCartFail === 'function') {
        window.$s.addToCartFail(msg);
      } else {
        alert(msg);
      }
    })
    .finally(function () {
      if (btn) btn.removeAttribute('disabled');
    });
  }

  function initAjaxAtc() {
    var handler = function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('.reg-lp')) return;
      e.preventDefault();
      e.stopPropagation();
      doAjaxAdd(form);
    };

    // Capture phase fires before any bubble-phase handler can interfere.
    document.addEventListener('submit', handler, true);

    // Also attach directly to each form as a redundant safety net.
    document.querySelectorAll('.reg-lp form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.regAtcInit === '1') return;
      form.dataset.regAtcInit = '1';
      form.addEventListener('submit', handler);
    });
  }

  function init() {
    document.querySelectorAll('[data-reg-faq]').forEach(initFaq);
    document.querySelectorAll('[data-reg-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-reg-offer]').forEach(initOffer);
    initAnchors();
    initAjaxAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
